// extracted by mini-css-extract-plugin
module.exports =  {"clickable":"Clickable-module__clickable___JhbYc"};